import { BlogPost } from "./types";

// Import individual blog posts
import { whatIsArtificialIntelligence } from "./posts/what-is-artificial-intelligence";
import { howChatGPTWorks } from "./posts/how-chatgpt-works";
import { aiInHealthcare2025 } from "./posts/ai-in-healthcare-2025";
import { understandingLargeLanguageModels } from "./posts/understanding-large-language-models";
import { aiEthicsAndResponsibility } from "./posts/ai-ethics-and-responsibility";
import { futureOfAIJobs } from "./posts/future-of-ai-jobs";
import { machineLearningVsDeepLearning } from "./posts/machine-learning-vs-deep-learning";
import { aiAPICompleteGuide } from "./posts/ai-api-complete-guide";
import { openAIAPIGuide } from "./posts/openai-api-guide";
import { buildingAIChatbot } from "./posts/building-ai-chatbot";
import { aiCostManagementGuide } from "./posts/ai-cost-management-guide";
import { optimizingAIAPIUsage } from "./posts/optimizing-ai-api-usage";
import { aiInBusinessTransformation } from "./posts/ai-in-business-transformation";
import { generativeAIExplained } from "./posts/generative-ai-explained";
import { aiImageGenerationGuide } from "./posts/ai-image-generation-guide";
import { understandingAITokensAndAPICosts } from "./posts/understanding-ai-tokens-and-api-costs";

// Export all blog posts
export const allBlogPosts: BlogPost[] = [
  understandingAITokensAndAPICosts,
  whatIsArtificialIntelligence,
  howChatGPTWorks,
  aiInHealthcare2025,
  understandingLargeLanguageModels,
  aiEthicsAndResponsibility,
  futureOfAIJobs,
  machineLearningVsDeepLearning,
  aiAPICompleteGuide,
  openAIAPIGuide,
  buildingAIChatbot,
  aiCostManagementGuide,
  optimizingAIAPIUsage,
  aiInBusinessTransformation,
  generativeAIExplained,
  aiImageGenerationGuide,
];
